export default __webpack_public_path__ + "static/media/miscellaneous18.512d0698.png";